import { restApiClient } from '@/datasources';

export const REMOVE_CART_ITEMS_ROUTE = '/online/cart/bulk-delete-cart-items';

export async function removeCartItems(cartItemsIds: string[]): Promise<void> {
  await restApiClient.post(REMOVE_CART_ITEMS_ROUTE, { cartItemsIds });
}
